import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexDescriptionsComponent } from './index-descriptions.component';

import { RouterModule } from '@angular/router';



@NgModule({
    imports: [
    CommonModule,
    RouterModule.forChild([
        { path: '', component: IndexDescriptionsComponent }
    ]),
    IndexDescriptionsComponent
]
})
export class IndexDescriptionsModule { }
